import { useRef, useEffect } from "react";

const useDidMount = () => {
  const didMount = useRef(false);

  useEffect(() => {
    didMount.current = true;
  }, []);

  return didMount.current;
};

export default useDidMount;
